export const TO_BE_TREATED = "ToBeTreated";
export const ARCHIVED = "Archived";
export const TRANSFORMED = "Transformed";

const status = <const>[ARCHIVED, TO_BE_TREATED, TRANSFORMED];
export type RequestForInformationStatus = typeof status[number];
